export const CronberryLogo = ({ className = "h-12 w-12" }) => {
  return (
    <img
      src="https://customer-assets.emergentagent.com/job_asset-manager-165/artifacts/216imjd5_2%20%281%29.jpg"
      alt="Cronberry Logo"
      className={className}
      style={{ objectFit: 'contain' }}
    />
  );
};

export default CronberryLogo;